import { render, staticRenderFns } from "./ShopManageDetail.vue?vue&type=template&id=f3640000&scoped=true&"
import script from "./ShopManageDetail.vue?vue&type=script&lang=js&"
export * from "./ShopManageDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopManageDetail.vue?vue&type=style&index=0&id=f3640000&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3640000",
  null
  
)

export default component.exports